import { L } from '@lang';
import { ReactComponent as LogoIcon } from '../../shared/assets/logo.svg';
import { InstallPage, Placeholder, Button } from '../../shared/ui';
import { envs } from '../../core';
import styles from './PwaDisabledAndroid.module.css';

export function PwaDisabledAndroid() {
  return (
    <InstallPage className={styles.root}>
      <Placeholder
        icon={<LogoIcon />}
        title={L.t('pwa_disabled_android_placeholder_title')}
        action={
          <Button onClick={() => window.open(envs.GOOGLE_PLAY_STORE_URL, '', 'noopener,noreferrer')} stretched>
            {L.t('pwa_disabled_android_placeholder_action')}
          </Button>
        }
        stretched
      />
    </InstallPage>
  );
}
